import { CloseCircleGreyIcon } from "assets";
import { ModalPortal, MODAL_LAYER } from "components/modal-portal";

/** What the user was doing when they ran out — only changes the copy. */
type ModalVariant = "candidates" | "cv-analyzed";

interface UnlockFullReportsModalProps {
  isOpen: boolean;
  onClose: () => void;
  variant?: ModalVariant;
  candidateCount?: number;
  cvCount?: number;
  onTopupCredit?: () => void;
}

/** Shown when credits run out with reports still waiting to be opened. */
const UnlockFullReportsModal = ({
  isOpen,
  onClose,
  variant = "candidates",
  candidateCount = 0,
  cvCount = 0,
  onTopupCredit,
}: UnlockFullReportsModalProps) => {
  if (!isOpen) return null;

  const subtitle =
    variant === "cv-analyzed" ? (
      <>
        Great progress! You've analyzed <span className="font-bold text-[#344054]">{cvCount} CVs</span>, but your
        credits are now exhausted.
      </>
    ) : candidateCount > 0 ? (
      <>
        <span className="font-bold text-[#012169]">{candidateCount}</span> more candidates have completed the
        assessment, but your credits are now exhausted.
      </>
    ) : (
      "More candidates have taken the assessment, but you've exhausted your credits."
    );

  return (
    <ModalPortal>
      <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex: MODAL_LAYER.gate }}>
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black/50" onClick={onClose} />

        {/* Modal */}
        <div className="relative bg-white rounded-2xl max-w-lg w-full mx-4 overflow-hidden">
          <button
            onClick={onClose}
            aria-label="Close"
            className="absolute top-6 right-4 z-10 hover:opacity-80 transition-opacity"
          >
            <CloseCircleGreyIcon className="w-8 h-8" />
          </button>

          <div className="p-8 pt-12">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-[#012169] mb-4">Unlock Full Reports</h2>
              <p className="text-[#667085]">{subtitle}</p>
              <p className="text-[#344054] font-semibold mt-1">Top up to view their reports.</p>
            </div>

            <button
              onClick={onTopupCredit}
              className="w-full py-4 rounded-lg font-medium bg-[#012169] text-white hover:bg-[#011557] transition-colors"
            >
              Topup Credit
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export { UnlockFullReportsModal };
